const uagent = navigator.userAgent.toLowerCase();

const config_development = {
  // baseUrl: "http://192.168.0.76:9012/",
  baseUrl: "http://localhost:9012/",
  // sessionID: "982bdc38-0ade-47af-9406-f140505ebdc1",//测试环境 yxdczh0000000202
  // sessionID: "a5f6a043-88b2-4a00-ad37-cb047a94ac35",//测试环境 yxdczh0000000186 云职训演示 蒋浩军
  sessionID: "00386fc3-6e39-4d09-b651-5a24622d96ad",//测试环境 yxdczh0000000187 星辰大讲堂 蒋浩军
  sessionID: "8e873b37-593d-4446-b540-eb667df02cf4",//测试环境 yxdczh0000000202 职业百科
  sessionID: "1509c745-9c58-4f2a-af38-727a57b9e6c5",//测试环境 yxqqnn2800000004 甘肃农业大学
  liveHost: "ws://192.168.0.92:9888",

  // baseUrl: "https://m-train.bysjy.com.cn/",
  // sessionID: "e6a89f10-2f76-4e72-9cc4-3ad7dc622680",//正式环境TOKEN yxdczh0000000202 蒋浩军
  // sessionID: "eaf89d29-4051-4837-94b3-db12f03a5214",//正式环境TOKEN yxdczh0000000186 单鹏
  // sessionID: "0e260e13-95f4-4667-9cef-589f328ba85b",//正式环境TOKEN yxdczh0000000187 蒋浩军
  // sessionID: "c1d48fba-7c08-4de8-b7b2-be5c781e7515",//正式环境TOKEN yxdczh0000000187 蒋浩军
  // liveHost: "wss://webdis.bysjy.com.cn",
  gate_users: ['*']
};

const config_production = {
  baseUrl: "https://m-train.bysjy.com.cn/",
  sessionID: "2871e134-4060-450e-91e0-3df0af62d428",//正式环境TOKEN, 单鹏
  sessionID: "2871e134-4060-450e-91e0-3df0af62d428",//正式环境TOKEN, 单鹏
  liveHost: "wss://webdis.bysjy.com.cn",
  gate_users: ['27471']
}

const config_testing = {
  baseUrl: "http://192.168.0.92:9012/",
  sessionID: "982bdc38-0ade-47af-9406-f140505ebdc1",
  liveHost: "ws://192.168.0.92:9888",
  gate_users: ['*']
}
console.log('NODE_ENV', process.env.NODE_ENV);

let base_config = {};
if(process.env.NODE_ENV=='production'){
  console.log('配置文件：', 'production');
  base_config = config_production;
}
if(process.env.NODE_ENV=='testing'){
  console.log('配置文件：', 'testing');
  base_config = config_testing;
}
if(process.env.NODE_ENV=='development'){
  console.log('配置文件：', 'development');
  base_config = config_development;

}

export default {
  iOS: /ip(hone|ad|od)/.test(uagent),
  android: /android/.test(uagent),
  wx: /micromessenger/.test(uagent),
  wxpc: /windowswechat/.test(uagent),
  wechatdevtools: /wechatdevtools/.test(uagent),
  wxwork: /wxwork/.test(uagent),
  base_config: base_config,
};
